export enum ContentListType {
  ALL = 'ALL',
  PINNED = 'PINNED'
}
